if (!window.__piReviewsScrollBound) {
  window.__piReviewsScrollBound = true;

  var SCROLL_DURATION = 300;

  /**
   * @param {number} t
   */
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  /**
   * @param {Element} target
   */
  function animatedScrollTo(target) {
    var startY = window.scrollY;
    var endY = startY + target.getBoundingClientRect().top;
    var distance = endY - startY;
    /** @type {number | null} */
    var startTime = null;

    /**
     * @param {number} timestamp
     */
    function step(timestamp) {
      if (startTime === null) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / SCROLL_DURATION, 1);

      window.scrollTo(0, startY + distance * easeInOutQuad(progress));

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.reviews-summary__link[href^="#"]');
    if (!link) return;

    var targetId = link.getAttribute('href').slice(1);
    var target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    event.preventDefault();
    animatedScrollTo(target);
  });
}
